import React, { useState, useEffect } from "react";
import { useAuth, UseDrawer } from "../../context";
import { useNavigate } from "react-router-dom";
import { Box, Drawer, Paper, IconButton } from "@mui/material";
import { List, ListItemIcon, ListItemButton, ListItemText } from "@mui/material";
import { LogoutIcon, MenuIcon } from "../icon/index";
import ListLink from "./ListLink";
import { styled } from '@mui/system';

export const Sidebar = ({ children }) => {
    const { isDrawerOpen, drawerOptions, toggleDrawerOpen } = UseDrawer();
    const navigate = useNavigate();
    const { logon } = useAuth();
    const [menuWidth, setMenuWidth] = useState(20);

    const handleLogon = async () => {
        logon();
        navigate("/home");
    };

    const StyledBox = styled(Box)({
        left: !isDrawerOpen ? `calc(${menuWidth}vw)` : '0px',
        zIndex: 1000,
    });

    const MenuButton = () => {
        return (
            <StyledBox>
                <IconButton
                    color="inherit"
                    aria-label={!isDrawerOpen ? "Fechar menu" : "Abrir menu"}
                    onClick={toggleDrawerOpen}
                >
                    <MenuIcon color="primary" sx={{ fontSize: '2em' }} />
                </IconButton>
            </StyledBox>
        );
    };

    useEffect(() => {
        // Atualize a largura do menu sempre que o estado do menu for alterado
        const updateMenuWidth = () => {
            const drawer = document.getElementById("sidebar-drawer");
            if (drawer) {
                setMenuWidth(20);
            }
        };
        updateMenuWidth();
        window.addEventListener("resize", updateMenuWidth);
        return () => {
            window.removeEventListener("resize", updateMenuWidth); // Remova o ouvinte de redimensionamento ao desmontar o componente
        };
    }, [isDrawerOpen]);

    return (
        <>
            <Drawer variant="persistent" open={!isDrawerOpen} onClose={toggleDrawerOpen}>
                <Box
                    id="sidebar-drawer"
                    display="flex"
                    flexDirection="column"
                    width={`${menuWidth}vw`}
                    minHeight="97vh"
                >
                    <Paper>
                        <Box padding={2}>
                            <h1>{localStorage.getItem('@gedy:user')}</h1>
                        </Box>
                    </Paper>
                    <Box padding={2} flex={1}>
                        <List component={'nav'}>
                            {drawerOptions.map(itens => (
                                <ListLink key={itens.path} iconType={itens?.icon} label={itens?.label} to={itens?.path} />
                            ))}
                        </List>
                    </Box>
                    <Box padding={2} marginTop="auto">
                        <List component={'nav'}>
                            <ListItemButton onClick={handleLogon}>
                                <ListItemIcon>
                                    <LogoutIcon color="primary" />
                                </ListItemIcon>
                                <ListItemText primary="Sair" />
                            </ListItemButton>
                        </List>
                    </Box>
                </Box>
            </Drawer>
            <Box height="100vh" marginLeft={!isDrawerOpen ? `${menuWidth}vw` : '0vw'} padding={2}>
                <MenuButton />
                {children}
            </Box>
        </>
    );
};
